/*
 *
 * HubspotVerify actions
 *
 */

import { VERIFY_HUBSPOT } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyHubspot = {
  start: ({ payload, metadata }) => defineAction({ type: VERIFY_HUBSPOT.START, payload, metadata }),
  success: () => {
    return defineAction({ type: VERIFY_HUBSPOT.SUCCESS });
  },
  error: ({ error }) =>
    defineAction({
      type: VERIFY_HUBSPOT.ERROR,
      payload: {
        error,
      },
    }),
};
